<script setup lang="ts">
import TagDropdown from "~/components/Common/Dropdowns/TagDropdown.vue";
import Tooltip from "~/components/Common/Tooltip.vue";
import { useUsersStore } from "~/store/users/users.store";
import type { UserCompanyModel } from "@simbelapp/order-sdk";
import { useCompanyUsersDropdown } from "~/composables/users/useCompanyUsersDropdown";

const props = defineProps(["modelValue", "title", "disabled", "searchable", "multiple", "add"]);
const emit = defineEmits(["update:modelValue"]);
const usersStore = useUsersStore();

const { companyUsers } = storeToRefs(usersStore);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const searchValue = ref("");

function createNewEmail() {
  value.value.push({
    email: searchValue.value,
  });
}

const { companyUsersServicesAPI } = useCompanyUsersDropdown();
</script>

<template>
  <div class="flex flex-col gap-2">
    <slot name="header">
      <h5 v-if="title" class="body_regular text-secondary-color mb-2">{{ title }}</h5>
    </slot>
    <TagDropdown
      v-model="value"
      :loading="!companyUsers"
      :options="companyUsers?.filter((user) => user.email)"
      placeholder="Ajouter un destinataire"
      :disabled="disabled"
      :searchable="searchable"
      :multiple="multiple"
      :add="add"
      :store="usersStore"
      store-object="companyUsers"
      :services-a-p-i="companyUsersServicesAPI"
      label="displayValue"
      track-by="displayValue"
      @searchValue="
        (value) => {
          searchValue = value;
        }
      "
      @clickAdd="createNewEmail"
    >
      <template #tag="{ option }">
        <Tooltip
          v-if="option.email && option.displayValue"
          :position="'top-mid'"
          append-to-body
          :force-position-top="5"
          minified
        >
          <template #img
            ><span>{{ option.email }}</span></template
          >
          <template #content>
            <div class="flex w-fit whitespace-nowrap gap-[8px]">
              {{ option.displayValue }}
            </div>
          </template>
        </Tooltip>
        <span v-else>{{ option.email }} </span>
      </template>
      <template #option="{ option }">
        <span>{{ option.displayValue }} </span>
      </template>
    </TagDropdown>
  </div>
</template>

<style lang="scss"></style>
